<template>
  <div>
    <button type="button" name="button" @click="confirmSignature">签字</button>
    <div class="signature-image">
      <van-image width="100" :src="imageSrc"/>
    </div>
    <steam-signature :isSignaturePadVisible="signaturePadVisible" :signOptions="options" @closePopup="closePopup" @saveSignature="saveSignature"/>
  </div>
</template>
<script>
import SteamSignature from '@/components/SteamComponents/steamSignature.vue'
export default{
  components:{
    SteamSignature
  },
  data(){
    return {
      signaturePadVisible:false,
      options:{
        penColor: "#c0f",
      },
      imageSrc:""
    }
  },
  methods:{
    confirmSignature(){
      this.signaturePadVisible = true;
      this.options = {
        penColor: "#c0f",
      };
    },
    closePopup(){
      this.signaturePadVisible = false;
    },
    saveSignature(data){
      //console.log('data',data);
      this.signaturePadVisible = false;
      this.imageSrc = data;
    }
  }

}
</script>
